module.exports = __webpack_public_path__ + "img/card_pay.ed732b78.png";